import { Component, Input, OnInit } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalService } from 'ng-zorro-antd/modal';
import { JobSignatureService } from '../../../../service/job-signature.service';

@Component({
  selector: 'app-job-signature',
  templateUrl: './job-signature.component.html',
  styleUrls: ['./job-signature.component.less']
})
export class JobSignatureComponent implements OnInit {

  @Input() jobId: any;
  signatureList = [];
  constructor(
    private jobSignatureService: JobSignatureService,
    private modalService: NzModalService,
    private messageService: NzMessageService
  ) { }

  ngOnInit(): void {
    this.getSignatureList(this.jobId);
  }
  getSignatureList(jobId: any){
    this.jobSignatureService.getJobSignatureListByJno(jobId).then((response: any) => {
      if (response != null){
        this.signatureList =  response;
      }
    });
  }
  deleteSignature(id: any){
    this.modalService.confirm({
      nzTitle: '确定删除该签名？',
      nzContent: '<b style="color: red;">删除之后不可恢复，谨慎操作！</b>',
      nzOkText: '确定',
      nzCancelText: '取消',
      nzOkType: 'danger',
      nzOnOk: () => {
        this.jobSignatureService.deleteJobSignature(id).then((result: any) => {
          if ( result != null){
            this.getSignatureList(this.jobId);
          }else{
            this.messageService.error('删除失败');
          }
        });
      }
    });
  }
}
